import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderFinishedCargoOrdersUnbilledList from "./order-finished-cargo-orders-unbilled-list";
import OrderFinishedCargoOrdersUnbilledListParams from "./order-finished-cargo-orders-unbilled-list-params";

const useOrderFinishedCargoOrdersUnbilledList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderFinishedCargoOrdersUnbilledList | null>(null);

  const load = async (
    params: OrderFinishedCargoOrdersUnbilledListParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await orderService.getOrderFinishedUnbilledList(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderFinishedCargoOrdersUnbilledList;
